import React, { useEffect, useMemo, useState } from 'react';
import { Box, Breadcrumbs, Link } from '@mui/material';
import { Table } from '@components';
import { useModal } from 'mui-modal-provider';
const OblerProcessosAgendarView = ({ $state, UIService }) => {
    const loadParams = () => {
        const sortBy = $state.params.sortBy;
        if (sortBy == undefined) {
            return [];
        }
        const o = [];
        sortBy.forEach(r => {
            const s = r.split(':');
            o.push({ id: s[0], desc: s[1] == 'DESC' });
        });
        return o;
    };
    const { showModal } = useModal();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const [refetching, setRefetching] = useState(false);
    const [options, setOptions] = useState({
        filter: [],
        sort: []
    });
    const [pagination, setPagination] = useState({
        pageIndex: $state.params.page - 1 || 0,
        pageSize: $state.params.limit || 20
    });
    const [filter, setFilter] = useState([]);
    const [sort, setSort] = useState(() => loadParams());
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: '#',
            size: 100,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.oi.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'numeroProcesso',
            header: 'Nº Processo',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.oi.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'Parceiro',
            header: 'Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.oi.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'numeroParceiro',
            header: 'Nº Parceiro',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.oi.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'interacaoId',
            header: '# Interacao',
            size: 150,
            Cell: ({ renderedCellValue, row }) => (<Link underline='none' color='default' sx={{ fontWeight: 'bold' }} target={'_blank'} href={$state.href('app.obler.oi.details', { id: row.original.id }, { absolute: true })}>
            {renderedCellValue}
          </Link>)
        },
        {
            accessorKey: 'sumEncomendas',
            header: 'Nº Encomendado',
            size: 150
        },
        {
            accessorKey: 'totalEncomendas',
            header: 'Total Encomendado (€)',
            size: 150,
            muiTableHeadCellProps: {
                align: 'right'
            },
            muiTableBodyCellProps: {
                align: 'right'
            },
            Cell: ({ cell }) => <span>{cell.getValue().toLocaleString('pt-PT', { style: 'currency', currency: 'eur', maximumFractionDigits: 2 })}</span>
        },
        {
            accessorKey: 'Agendamento.data',
            header: 'Data Interação',
            size: 150
        },
        {
            accessorKey: 'Agendamento.Tecnico.nome',
            header: 'Técnico',
            size: 150
        },
        {
            accessorKey: 'Validacao.data',
            header: 'Data Validação',
            size: 150
        },
        {
            accessorKey: 'Validacao.Tecnico.nome',
            header: 'Validado Por',
            size: 150
        }
    ], []);
    const getType = (type) => {
        switch (type) {
            case 'contains':
                return '$ilike';
            case 'startsWith':
                return '$sw';
            case 'notEquals':
                return '$not';
            case 'empty':
                return '$null';
            case 'notEmpty':
                return '$notNull';
            case 'greaterThan':
                return '$gt';
            case 'greaterThanOrEqualTo':
                return '$gte';
            case 'lessThan':
                return '$lt';
            case 'lessThanOrEqualTo':
                return '$lte';
            default:
                return '$eq';
        }
    };
    const initialFetch = async () => {
        if (loading) {
            setLoading(false);
            // TODO: Parceiros
        }
    };
    const fetchData = async () => {
        try {
            let filters = {};
            filter.forEach(r => {
                filters[r.id] = `${getType(r.type)}:${r.value}`;
            });
            let sorter = [];
            sort.forEach(r => {
                sorter.push(`${r.id}:${r.desc ? 'DESC' : 'ASC'}`);
            });
            const aux = await GasService.findProcessos({
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                filter: filters,
                sortBy: sorter
            });
            $state.go($state.current.name, {
                limit: pagination.pageSize,
                page: pagination.pageIndex + 1,
                sortBy: sorter,
                filter: Object.keys(filter).length > 0 ? JSON.stringify(filters) : undefined
            }, {
                notify: false,
                reload: false,
                location: 'replace',
                inherit: true
            });
            // Update URL
            console.log(aux);
            setData(aux);
        }
        catch (e) { }
        let aux = {
            meta: {
                totalItems: 1,
                currentPage: 1,
                itemsPerPage: 20,
                totalPages: 1
            },
            data: [
                {
                    id: 1,
                    numeroProcesso: '20250012',
                    Parceiro: 'Worten Resolve',
                    numeroParceiro: 'WR012391000A',
                    interacaoId: '20250012.1',
                    sumEncomendas: 2,
                    totalEncomendas: 147.25,
                    Agendamento: {
                        Tecnico: {
                            nome: 'João Leite'
                        },
                        data: '2025-02-07 15:30'
                    },
                    Validacao: {
                        Tecnico: {
                            nome: 'Élio Gouveia'
                        },
                        data: '2025-02-11 16:19'
                    }
                }
            ],
            links: {}
        };
        setData(aux);
        setRefetching(false);
    };
    useEffect(() => {
        initialFetch();
        if (!refetching) {
            setRefetching(true);
            fetchData();
        }
    }, [pagination, filter, sort]);
    return (<Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link underline='none' color='inherit'>
            Obler
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            Orçamentos
          </Link>
          <Link underline='hover' color='text.primary' aria-current='page'>
            A agendar
          </Link>
        </Breadcrumbs>
      </Box>

      <Box>
        <Table onDoubleClick={row => {
            window.open($state.href('app.obler.oi.details', { id: row.id }, { absolute: true }));
        }} storageKey={$state.current.name} data={data} columns={columns} initial={{
            sort: sort,
            filter: filter
        }} isLoading={refetching} options={options} onPaginate={setPagination} onFilter={setFilter} onSort={setSort}/>
      </Box>
    </Box>);
};
export default OblerProcessosAgendarView;
